import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {AuthService} from '../../../../../core/service/auth.service';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaCallerIdService} from '../../services/vna-caller-id.service';
import {VnaCallerIdSelected} from '../../model/VnaCallerIdSelected';

const SELECT_VNA_CALLER_ID_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectCallerIdsComponent)
};

@Component({
    selector: 'app-select-caller-ids',
    template: `
      <ngx-select [items]="callerIds" [(ngModel)]="callerId" [optionValueField]="valueField" [optionTextField]="textField" (select)="selected($event)" allowClear="true">
          <ng-template ngx-select-option let-option let-text="text">
              <img src="assets/img/flags/{{ option.data.portal | lowercase}}.png" />&nbsp;{{ option.data.number }}<br />
              <span *ngIf="option.data.description.length > 0"><small><em>{{option.data.description}}</em></small></span>
              <span *ngIf="option.data.description.length == 0"><small><em>No description</em></small></span>
          </ng-template>
          <ng-template ngx-select-option-selected let-option let-text="text">
              <img src="assets/img/flags/{{ option.data.portal | lowercase}}.png" />&nbsp;{{ option.data.number }}
          </ng-template>
      </ngx-select>
      `,
    styleUrls: ['./select-caller-ids.component.scss'],
    providers: [SELECT_VNA_CALLER_ID_VALUE_ACCESSOR]
})
export class SelectCallerIdsComponent implements OnInit, ControlValueAccessor {

    @Input() valueField: string = 'pk';
    @Input() textField: string = 'number';

    callerIds: Array<Object> = [];
    _callerId: number;

    constructor(private callerIdsService: VnaCallerIdService, private messaging: MessagingService, private auth: AuthService) { }

    ngOnInit() {
        this.callerIdsService.findCallerIds({'active' : 1}).subscribe(
            (result) => {
                this.callerIds = result;
            }
        );
    }


    selected(value: any) {
        this.messaging.sendMessage(new VnaCallerIdSelected(value));
        this.propagateChange(this._callerId);
    }

    get callerId(): any { return this._callerId; };

    set callerId(v: any) {
        this._callerId = v;
        this.propagateChange(this._callerId);
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(value: any): void {
        this._callerId = value;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/caller-id/components/select-caller-ids/select-caller-ids.component.ts